import type { AmplitudeExperimentsContext } from '@/store/slices/customerData/types';

export const isExperimentInTreatment = (
  experiments: AmplitudeExperimentsContext,
  key: string,
): boolean =>
  (experiments?.[key] as { value?: string } | undefined)?.value === 'treatment';
